<section
  class="relative min-h-screen max-w-[1500px] mx-auto mt-32">
  <div
    class="max-w-[1000px] mx-auto flex flex-col text-4xl md:text-8xl lg:text-18xl xl:text-22xl text-center font-secondary font-extrabold py-5 md:py-8 px-5 md:px-16 leading-[fit-content] xl:leading-20">
      <h1 i18n="@@autopark-challanges.title" class="max-auto text-secondary-650">
      Odkryj wyzwania, które podejmuje
        <span class="text-primary-500">
          parking z ProcessWay
        </span>
      </h1>
  </div>
  <div class="w-full max-w-7xl mx-auto px-5 sm:px-10 md:px-16 lg:px-4 py-12 md:py-20">
    <div class="flex justify-center mb-8">
      <p-tabs [value]="activeTab">
        <p-tablist>
          @for (tab of tabs; track tab.value) {
            <p-tab [value]="tab.value">
              {{ tab.label }}
            </p-tab>
          }
        </p-tablist>
        <p-tabpanels>
          @for (tab of tabs; track tab.value) {
            <p-tabpanel [value]="tab.value">
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center pt-8">
                <div class="order-2 lg:order-1 space-y-6">
                  <h3 class="text-2xl md:text-3xl font-bold text-primary-500 font-secondary leading-tight">
                    {{ tab.title }}
                  </h3>
                  <p class="text-base md:text-lg text-gray-600 leading-relaxed">
                    {{ tab.content }}
                  </p>
                </div>

                <div class="order-1 lg:order-2">
                  <div
                    class="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-blue-50 to-indigo-100 aspect-[4/3]">
                    <img
                      [src]="tab.image"
                      [alt]="tab.title"
                      class="w-full h-full object-cover"/>
                  </div>
                </div>
              </div>
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>
</section>
